import http from 'conversations-http/clients/http';
export const fetchSpamViewMembersService = () => {
  return http.get(`threadlists/v1/members/spam-view-members-for-helpdesk`);
};